const TabPage = ({ tabList, selectedTab, setSelectedTab, children }) => {
  return (
    <div className={"flex flex-col gap-4 w-full justify-center h-full"}>
      <div className={"flex flex-row justify-center"}>
        {tabList?.map((item, index) => {
          const lastIndex = tabList?.map((item, index) => index)[
            tabList.length - 1
          ];
          return (
            <button
              className={`p-2 text-black ${
                index === 0
                  ? "rounded-s-md"
                  : index === lastIndex && "rounded-e-md"
              } font-bold flex flex-row gap-1 items-center text-sm ${
                index === selectedTab
                  ? "bg-[#4ee481] hover:bg-buttonPrimary transition-transform"
                  : "bg-white"
              }`}
              key={`tab_${index}`}
              onClick={() => setSelectedTab(index)}
            >
              {item?.icon && (
                <img src={item?.icon} alt={item.title} className={"w-[20px]"} />
              )}
              {item.title}
            </button>
          );
        })}
      </div>
      {children}
    </div>
  );
};
export default TabPage;
